import { Box, Skeleton, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useWin32AppWdacFileCounts } from 'src/hooks/wdac';
import { PORTAL_ROUTE } from 'src/constants/routes';
import { formatCount } from 'src/utils/formatNumber.util';
import {
  AllClearCallout,
  CardTitle,
  DetectedCallout,
  OVERVIEW_CARD_SX as CARD_SX,
} from 'src/features/charts/OverviewCard';
import { COVERAGE_CARDS } from '../TelemetryTab/constants';

// Side by side so the card stays two rows tall; a lone action keeps its half rather than stretching.
const ACTIONS_GRID_SX = {
  display: 'grid',
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
  gap: 1,
};

// Each coverage callout opens the Telemetry tab on its coverage filter. The counts read the same 90
// days the tab defaults to, so the number here is the number of rows that open. A gap between the
// trust and its artifacts opens the step that builds them.
const DetectedActionsCard = ({ globalApplicationVersionId, artifactsAction, onOpenArtifacts }) => {
  const navigate = useNavigate();
  const { data: counts, isLoading } = useWin32AppWdacFileCounts({
    globalApplicationVersionId,
  });

  const detected = COVERAGE_CARDS.filter(card => counts?.[card.countKey] > 0);

  return (
    <Stack gap={1} sx={CARD_SX}>
      <CardTitle title="Detected Actions" />
      {isLoading ? (
        <Skeleton variant="rounded" height={52} sx={{ bgcolor: '#4B4B4B' }} />
      ) : detected.length === 0 && !artifactsAction ? (
        <Box sx={ACTIONS_GRID_SX}>
          <AllClearCallout />
        </Box>
      ) : (
        <Box sx={ACTIONS_GRID_SX}>
          {artifactsAction ? (
            <DetectedCallout
              icon="mdi:package-variant-closed"
              accent="#E0A23C"
              title={artifactsAction.title}
              subtitle={artifactsAction.subtitle}
              onClick={onOpenArtifacts}
            />
          ) : null}
          {detected.map(card => {
            const count = counts[card.countKey];

            return (
              <DetectedCallout
                key={card.countKey}
                icon="mdi:shield-alert-outline"
                accent="#E0A23C"
                title={`${formatCount(count)} reported ${count === 1 ? 'file' : 'files'} ${
                  card.label
                }`}
                subtitle={card.nextStep}
                onClick={() =>
                  navigate(
                    `${PORTAL_ROUTE}/wdac-apps/${globalApplicationVersionId}/telemetry?isCovered=${card.isCovered}`,
                  )
                }
              />
            );
          })}
        </Box>
      )}
    </Stack>
  );
};

export default DetectedActionsCard;
